import { environment } from "../../environments/environment";

export const API_KEY = "e5e64753f3166ba712b1b0eead08f2b3";
export const API_URL = "https://ws.audioscrobbler.com/2.0/";
export const LAST_FM_DOWN = "Last.fm is down. Please try again later.";
export const USER_NOT_FOUND = "User not found";
export const NO_SUCH_PAGE = "no such page";

export const GETFRIENDS_URL = environment.backend_url + "/api/friends/";
// prettier-ignore
export const SCATTER_FM_USER_URL = "https://scatterfm.markhansen.co.nz/graph.html#/user/";
export const LAST_FM_USER_URL = "https://www.last.fm/user/";
export const EXPLR_FM_USER_URL = "https://mold.github.io/explr/?username=";
export const SERGEI_USER_URL = "https://sergei.app/";
// prettier-ignore
export const LAST_MILESTONES_USER_URL = "http://lastmilestones.tk/milestones?user=";

export const MS_PER_DAY = 86400000;
